import { SearchChatsData } from "@sms/shared/chat/search/search.interface";
import { createAction, EmptyAction, PayloadAction } from "typesafe-actions";

export const switchSearchWrapperAction: (isOpen: boolean) => PayloadAction<"search/switchSearchWrapper", boolean> =
  createAction("search/switchSearchWrapper")<boolean>();

export const searchChatAction: (query: string | null) => PayloadAction<"search/searchChatAction", string | null> =
  createAction("search/searchChatAction")<string | null>();

export const updateSearchResultsDataAction: (
  results: SearchChatsData
) => PayloadAction<"search/updateData", SearchChatsData> = createAction("search/updateData")<SearchChatsData>();

export const updateSearchResultsDataToDefaultEmptyAction: () => EmptyAction<"search/updateDataToDefault"> =
  createAction("search/updateDataToDefault")();

export const setIsLoadingSearchAction: (
  isLoading: boolean | null
) => PayloadAction<"search/setIsLoadingSearch", boolean | null> = createAction("search/setIsLoadingSearch")<
  boolean | null
>();
